import { RootState } from "../../index";

export const useQueryBuilderStore = (state: RootState) => state.queryBuilder.data;
